<template>
    <div>
     <b-modal size="xl" :id="ModalId" :visible="true" scrollable centered no-close-on-backdrop no-close-on-esc :title="TitleWindow" @close="this.emitEventCancel" @ok="handleOk" :ok-title="$t('Shared.TitleOK')"  @cancel="this.emitEventCancel" :cancel-title="$t('Shared.BtnCancel')">

         <Loading v-bind:IsLoading="this.Load" />
        <form ref="form_EditNote" @submit.stop.prevent="handleSubmit">
        <MdTitle v-bind:Text="'Condition Code'" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'" v-bind:StyleProp="'margin: 0 !important;'"/>
        <b-row>
          <b-col lg="3" md="3" sm="12">
                 <MdLookup
                    v-bind:Label="$t('Patient.Condition', {'num': '1'})"
                    v-bind:ModelCode="Claim.conditionCode1"
                    v-bind:ModelDescription="Claim.conditionCode1Description"
                    v-bind:RefCode="'Condition1'"
                    v-bind:Api="'conditions'"
                    v-bind:FieldCode="'code'"
                    v-bind:Fields="[]"
                    v-bind:FieldDescription="'shortDescription'"
                    :IsDisabled="false"
                    :SearchTitle="$t('Patient.Conditions')"
                    :InvalidFeedback="$t('Patient.InvalidConditionCode',{'num': '1'})"
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimCondition1'"
                    :GetValues="onCodeConditionOkModal"
                    :SearchFieldCode="'Code'"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                 <MdLookup
                    v-bind:Label="$t('Patient.Condition', {'num': '2'})"
                    v-bind:ModelCode="Claim.conditionCode2"
                    v-bind:ModelDescription="Claim.conditionCode2Description"
                    v-bind:RefCode="'Condition2'"
                    v-bind:Api="'conditions'"
                    v-bind:FieldCode="'code'"
                    v-bind:Fields="[]"
                    v-bind:FieldDescription="'shortDescription'"
                    :IsDisabled="false"
                    :SearchTitle="$t('Patient.Conditions')"
                    :InvalidFeedback="$t('Patient.InvalidConditionCode',{'num': '2'})"
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimCondition2'"
                    :GetValues="onCodeConditionOkModal"
                    :SearchFieldCode="'Code'"
                />
            </b-col>
             <b-col lg="3" md="3" sm="12">
                 <MdLookup
                    v-bind:Label="$t('Patient.Condition', {'num': '3'})"
                    v-bind:ModelCode="Claim.conditionCode3"
                    v-bind:ModelDescription="Claim.conditionCode3Description"
                    v-bind:RefCode="'Condition3'"
                    v-bind:Api="'conditions'"
                    v-bind:FieldCode="'code'"
                    v-bind:Fields="[]"
                    v-bind:FieldDescription="'shortDescription'"
                    :IsDisabled="false"
                    :SearchTitle="$t('Patient.Conditions')"
                    :InvalidFeedback="$t('Patient.InvalidConditionCode',{'num': '3'})"
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimCondition3'"
                    :GetValues="onCodeConditionOkModal"
                    :SearchFieldCode="'Code'"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                 <MdLookup
                    v-bind:Label="$t('Patient.Condition', {'num': '4'})"
                    v-bind:ModelCode="Claim.conditionCode4"
                    v-bind:ModelDescription="Claim.conditionCode4Description"
                    v-bind:RefCode="'Condition4'"
                    v-bind:Api="'conditions'"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'shortDescription'"
                    :IsDisabled="false"
                    v-bind:Fields="[]"
                    :SearchTitle="$t('Patient.Conditions')"
                    :InvalidFeedback="$t('Patient.InvalidConditionCode',{'num': '4'})"
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimCondition4'"
                    :GetValues="onCodeConditionOkModal"
                    :SearchFieldCode="'Code'"
                />
            </b-col>
        </b-row>
        <b-row>
          <b-col lg="3" md="3" sm="12">
                 <MdLookup
                    v-bind:Label="$t('Patient.Condition', {'num': '5'})"
                    v-bind:ModelCode="Claim.conditionCode5"
                    v-bind:ModelDescription="Claim.conditionCode5Description"
                    v-bind:RefCode="'Condition5'"
                    v-bind:Api="'conditions'"
                    v-bind:Fields="[]"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'shortDescription'"
                    :IsDisabled="false"
                    :SearchTitle="$t('Patient.Conditions')"
                    :InvalidFeedback="$t('Patient.InvalidConditionCode',{'num': '5'})"
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimCondition5'"
                    :GetValues="onCodeConditionOkModal"
                    :SearchFieldCode="'Code'"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                 <MdLookup
                    v-bind:Label="$t('Patient.Condition', {'num': '6'})"
                    v-bind:ModelCode="Claim.conditionCode6"
                    v-bind:ModelDescription="Claim.conditionCode6Description"
                    v-bind:RefCode="'Condition6'"
                    v-bind:Api="'conditions'"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'shortDescription'"
                    :IsDisabled="false"
                    v-bind:Fields="[]"
                    :SearchTitle="$t('Patient.Conditions')"
                    :InvalidFeedback="$t('Patient.InvalidConditionCode',{'num': '6'})"
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimCondition6'"
                    :GetValues="onCodeConditionOkModal"
                    :SearchFieldCode="'Code'"
                />
            </b-col>
             <b-col lg="3" md="3" sm="12">
                 <MdLookup
                    v-bind:Label="$t('Patient.Condition', {'num': '7'})"
                    v-bind:ModelCode="Claim.conditionCode7"
                    v-bind:ModelDescription="Claim.conditionCode7Description"
                    v-bind:RefCode="'Condition7'"
                    v-bind:Api="'conditions'"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'shortDescription'"
                    :IsDisabled="false"
                    v-bind:Fields="[]"
                    :SearchTitle="$t('Patient.Conditions')"
                    :InvalidFeedback="$t('Patient.InvalidConditionCode',{'num': '7'})"
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimCondition7'"
                    :GetValues="onCodeConditionOkModal"
                    :SearchFieldCode="'Code'"
                />
            </b-col>
        </b-row>
         <MdTitle v-bind:Text="'Occurrence Code'"  class="mb-1" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

         <b-row>
            <b-col lg="3" md="3" sm="12">
                 <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 1'"
                    v-bind:ModelCode="Claim.occurrence.occurencecode1"
                    v-bind:ModelDescription="Claim.occurrence.occurencecode1description"
                    v-bind:RefCode="'Occurrence1'"
                    v-bind:Api="'Occurrences'"
                    v-bind:Fields="[]"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'description'"
                    :SearchTitle="'Occurrence 1'"
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrence1'"
                    :GetValues="onCodeConditionOkModal"
                    :SearchFieldCode="'Code'"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                    <MdDateTime
                        :Label="'Date 1'"
                        :Model="Claim.occurrence.occurencedate1"
                        @input="Claim.occurrence.occurencedate1 = $event"
                        :Id="'OccuDate1'"
                        :Type="'date'"
                        :isRequired="false"
                        :isConfirm="false"
                        :ReadOnly="false">
                    </MdDateTime>
            </b-col>
             <b-col lg="3" md="3" sm="12">
                 <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 2'"
                    v-bind:ModelCode="Claim.occurrence.occurencecode2"
                    v-bind:ModelDescription="Claim.occurrence.occurencecode2description"
                    v-bind:RefCode="'Occurrence2'"
                    v-bind:Api="'Occurrences'"
                     v-bind:Fields="[]"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'description'"
                    :SearchTitle="'Occurrence 2'"
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrence2'"
                    :GetValues="onCodeConditionOkModal"
                    :SearchFieldCode="'Code'"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                    <MdDateTime
                        :Label="'Date 2'"
                        :Model="Claim.occurrence.occurencedate2"
                        @input="Claim.occurrence.occurencedate2 = $event"
                        :Id="'OccuDate2'"
                        :Type="'date'"
                        :isRequired="false"
                        :isConfirm="false"
                        :ReadOnly="false">
                    </MdDateTime>
            </b-col>
         </b-row>

          <b-row>
            <b-col lg="3" md="3" sm="12">
                 <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 3'"
                    v-bind:ModelCode="Claim.occurrence.occurencecode3"
                    v-bind:ModelDescription="Claim.occurrence.occurencecode3description"
                    v-bind:RefCode="'Occurrence3'"
                    v-bind:Api="'Occurrences'"
                     v-bind:Fields="[]"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'description'"
                    :SearchTitle="'Occurrence 3'"
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrence3'"
                    :GetValues="onCodeConditionOkModal"
                    :SearchFieldCode="'Code'"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdDateTime
                        :Label="'Date 3'"
                        :Model="Claim.occurrence.occurencedate3"
                        @input="Claim.occurrence.occurencedate3 = $event"
                        :Id="'OccuDate3'"
                        :Type="'date'"
                        :isRequired="false"
                        :isConfirm="false"
                        :ReadOnly="false">
                    </MdDateTime>
            </b-col>
             <b-col lg="3" md="3" sm="12">
                 <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 4'"
                    v-bind:ModelCode="Claim.occurrence.occurencecode4"
                    v-bind:ModelDescription="Claim.occurrence.occurencecode4description"
                    v-bind:RefCode="'Occurrence4'"
                    v-bind:Api="'Occurrences'"
                     v-bind:Fields="[]"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'description'"
                    :SearchTitle="'Occurrence 4'"
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrence4'"
                    :GetValues="onCodeConditionOkModal"
                    :SearchFieldCode="'Code'"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdDateTime
                        :Label="'Date 4'"
                        :Model="Claim.occurrence.occurencedate4"
                        @input="Claim.occurrence.occurencedate4 = $event"
                        :Id="'OccuDate4'"
                        :Type="'date'"
                        :isRequired="false"
                        :isConfirm="false"
                        :ReadOnly="false">
                    </MdDateTime>
            </b-col>
         </b-row>

            <b-row>
            <b-col lg="3" md="3" sm="12">
                 <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 5'"
                    v-bind:ModelCode="Claim.occurrence.occurencecode5"
                    v-bind:ModelDescription="Claim.occurrence.occurencecode5description"
                    v-bind:RefCode="'Occurrence5'"
                    v-bind:Api="'Occurrences'"
                    v-bind:FieldCode="'code'"
                     v-bind:Fields="[]"
                    v-bind:FieldDescription="'description'"
                    :SearchTitle="'Occurrence 5'"
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrence5'"
                    :GetValues="onCodeConditionOkModal"
                    :SearchFieldCode="'Code'"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
               <MdDateTime
                        :Label="'Date 5'"
                        :Model="Claim.occurrence.occurencedate5"
                        @input="Claim.occurrence.occurencedate5 = $event"
                        :Id="'OccuDate5'"
                        :Type="'date'"
                        :isRequired="false"
                        :isConfirm="false"
                        :ReadOnly="false">
                    </MdDateTime>
            </b-col>
             <b-col lg="3" md="3" sm="12">
                 <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 6'"
                    v-bind:ModelCode="Claim.occurrence.occurencecode6"
                    v-bind:ModelDescription="Claim.occurrence.occurencecode6description"
                    v-bind:RefCode="'Occurrence6'"
                    v-bind:Api="'Occurrences'"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'description'"
                    :SearchTitle="'Occurrence 6'"
                     v-bind:Fields="[]"
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrence6'"
                    :GetValues="onCodeConditionOkModal"
                    :SearchFieldCode="'Code'"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
              <MdDateTime
                        :Label="'Date 6'"
                        :Model="Claim.occurrence.occurencedate6"
                        @input="Claim.occurrence.occurencedate6 = $event"
                        :Id="'OccuDate6'"
                        :Type="'date'"
                        :isRequired="false"
                        :isConfirm="false"
                        :ReadOnly="false">
                    </MdDateTime>
            </b-col>
         </b-row>

          <b-row>
            <b-col lg="3" md="3" sm="12">
                 <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 7'"
                    v-bind:ModelCode="Claim.occurrence.occurencecode7"
                    v-bind:ModelDescription="Claim.occurrence.occurencecode7description"
                    v-bind:RefCode="'Occurrence7'"
                    v-bind:Api="'Occurrences'"
                    v-bind:FieldCode="'code'"
                     v-bind:Fields="[]"
                    v-bind:FieldDescription="'description'"
                    :SearchTitle="'Occurrence 7'"
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrence7'"
                    :GetValues="onCodeConditionOkModal"
                    :SearchFieldCode="'Code'"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
               <MdDateTime
                        :Label="'Date 7'"
                        :Model="Claim.occurrence.occurencedate7"
                        @input="Claim.occurrence.occurencedate7 = $event"
                        :Id="'OccuDate7'"
                        :Type="'date'"
                        :isRequired="false"
                        :isConfirm="false"
                        :ReadOnly="false">
                    </MdDateTime>
            </b-col>
             <b-col lg="3" md="3" sm="12">
                 <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 8'"
                    v-bind:ModelCode="Claim.occurrence.occurencecode8"
                    v-bind:ModelDescription="Claim.occurrence.occurencecode8description"
                    v-bind:RefCode="'Occurrence8'"
                    v-bind:Api="'Occurrences'"
                     v-bind:Fields="[]"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'description'"
                    :SearchTitle="'Occurrence 8'"
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrence8'"
                    :GetValues="onCodeConditionOkModal"
                    :SearchFieldCode="'Code'"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
               <MdDateTime
                        :Label="'Date 8'"
                        :Model="Claim.occurrence.occurencedate8"
                        @input="Claim.occurrence.occurencedate8 = $event"
                        :Id="'OccuDate8'"
                        :Type="'date'"
                        :isRequired="false"
                        :isConfirm="false"
                        :ReadOnly="false">
                    </MdDateTime>
            </b-col>
         </b-row>

           <b-row>
            <b-col lg="3" md="3" sm="12">
                 <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 9'"
                    v-bind:ModelCode="Claim.occurrence.occurencecode9"
                    v-bind:ModelDescription="Claim.occurrence.occurencecode9description"
                    v-bind:RefCode="'Occurrence9'"
                    v-bind:Api="'Occurrences'"
                    v-bind:FieldCode="'code'"
                     v-bind:Fields="[]"
                    v-bind:FieldDescription="'description'"
                    :SearchTitle="'Occurrence 9'"
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrence9'"
                    :GetValues="onCodeConditionOkModal"
                    :SearchFieldCode="'Code'"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdDateTime
                        :Label="'Date 9'"
                        :Model="Claim.occurrence.occurencedate9"
                        @input="Claim.occurrence.occurencedate9 = $event"
                        :Id="'OccuDate9'"
                        :Type="'date'"
                        :isRequired="false"
                        :isConfirm="false"
                        :ReadOnly="false">
                    </MdDateTime>
            </b-col>
           </b-row>
 <MdTitle v-bind:Text="'Occurrence Span'"  class="mb-1" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

        <b-row>
            <b-col lg="4" md="4" sm="12">
                <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 1'"
                    v-bind:ModelCode="Claim.occurrence.occurencespancode1"
                    v-bind:ModelDescription="Claim.occurrence.occurencespancode1description"
                    v-bind:RefCode="'Ospan1'"
                    v-bind:Api="'Occurrences'"
                     v-bind:Fields="[]"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'description'"
                    :SearchTitle="'Occurrence 1'"
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrencespan1'"
                    :GetValues="onCodeConditionOkModal"
                    :SearchFieldCode="'Code'"/>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                    <MdDateTime
                        :Label="'Date From 1'"
                        :Model="Claim.occurrence.occurencedatefrom1"
                        @input="Claim.occurrence.occurencedatefrom1 = $event"
                        :Id="'DateFrom1'"
                        :Type="'date'"
                        :isRequired="false"
                        :isConfirm="false"
                        :ReadOnly="false">
                    </MdDateTime>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                 <MdDateTime
                        :Label="'Date To 1'"
                        :Model="Claim.occurrence.occurencedateto1"
                        @input="Claim.occurrence.occurencedateto1 = $event"
                        :Id="'DateTo1'"
                        :Type="'date'"
                        :isRequired="false"
                        :isConfirm="false"
                        :ReadOnly="false">
                    </MdDateTime>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="4" md="4" sm="12">
                <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 2'"
                    v-bind:ModelCode="Claim.occurrence.occurencespancode2"
                    v-bind:ModelDescription="Claim.occurrence.occurencespancode2description"
                    v-bind:RefCode="'Ospan2'"
                    v-bind:Api="'Occurrences'"
                    v-bind:FieldCode="'code'"
                     v-bind:Fields="[]"
                    v-bind:FieldDescription="'description'"
                    :SearchTitle="'Occurrence 2'"
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrenceSpan2'"
                    :GetValues="onCodeConditionOkModal"
                    :SearchFieldCode="'Code'"/>
            </b-col>
             <b-col lg="4" md="4" sm="12">
                    <MdDateTime
                        :Label="'Date From 2'"
                        :Model="Claim.occurrence.occurencedatefrom2"
                        @input="Claim.occurrence.occurencedatefrom2 = $event"
                        :Id="'DateFrom2'"
                        :Type="'date'"
                        :isRequired="false"
                        :isConfirm="false"
                        :ReadOnly="false">
                    </MdDateTime>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                 <MdDateTime
                        :Label="'Date To 2'"
                        :Model="Claim.occurrence.occurencedateto2"
                        @input="Claim.occurrence.occurencedateto2 = $event"
                        :Id="'DateTo2'"
                        :Type="'date'"
                        :isRequired="false"
                        :isConfirm="false"
                        :ReadOnly="false">
                    </MdDateTime>
            </b-col>
        </b-row>
         <b-row>
            <b-col lg="4" md="4" sm="12">
                <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 3'"
                    v-bind:ModelCode="Claim.occurrence.occurencespancode3"
                    v-bind:ModelDescription="Claim.occurrence.occurencespancode3description"
                    v-bind:RefCode="'Ospan3'"
                    v-bind:Api="'Occurrences'"
                    v-bind:FieldCode="'code'"
                     v-bind:Fields="[]"
                    v-bind:FieldDescription="'description'"
                    :SearchTitle="'Occurrence 3'"
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrencespan3'"
                    :GetValues="onCodeConditionOkModal"
                    :SearchFieldCode="'Code'"/>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                    <MdDateTime
                        :Label="'Date From 3'"
                        :Model="Claim.occurrence.occurencedatefrom3"
                        @input="Claim.occurrence.occurencedatefrom3 = $event"
                        :Id="'DateFrom3'"
                        :Type="'date'"
                        :isRequired="false"
                        :isConfirm="false"
                        :ReadOnly="false">
                    </MdDateTime>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                 <MdDateTime
                        :Label="'Date To 3'"
                        :Model="Claim.occurrence.occurencedateto3"
                        @input="Claim.occurrence.occurencedateto3 = $event"
                        :Id="'DateTo3'"
                        :Type="'date'"
                        :isRequired="false"
                        :isConfirm="false"
                        :ReadOnly="false">
                    </MdDateTime>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="4" md="4" sm="12">
                <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 4'"
                    v-bind:ModelCode="Claim.occurrence.occurencespancode4"
                    v-bind:ModelDescription="Claim.occurrence.occurencespancode4description"
                    v-bind:RefCode="'Ospan4'"
                    v-bind:Api="'Occurrences'"
                     v-bind:Fields="[]"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'description'"
                    :SearchTitle="'Occurrence 4'"
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrencespan4'"
                    :GetValues="onCodeConditionOkModal"
                    :SearchFieldCode="'Code'"/>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                    <MdDateTime
                        :Label="'Date From 4'"
                        :Model="Claim.occurrence.occurencedatefrom4"
                        @input="Claim.occurrence.occurencedatefrom4 = $event"
                        :Id="'DateFrom4'"
                        :Type="'date'"
                        :isRequired="false"
                        :isConfirm="false"
                        :ReadOnly="false">
                    </MdDateTime>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                 <MdDateTime
                        :Label="'Date To 4'"
                        :Model="Claim.occurrence.occurencedateto4"
                        @input="Claim.occurrence.occurencedateto4 = $event"
                        :Id="'DateTo4'"
                        :Type="'date'"
                        :isRequired="false"
                        :isConfirm="false"
                        :ReadOnly="false">
                    </MdDateTime>
            </b-col>
        </b-row>
         <b-row>
            <b-col lg="4" md="4" sm="12">
                <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 5'"
                    v-bind:ModelCode="Claim.occurrence.occurencespancode5"
                    v-bind:ModelDescription="Claim.occurrence.occurencespancode5description"
                    v-bind:RefCode="'Ospan5'"
                    v-bind:Api="'Occurrences'"
                     v-bind:Fields="[]"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'description'"
                    :SearchTitle="'Occurrence 5'"
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrencespan5'"
                    :GetValues="onCodeConditionOkModal"
                    :SearchFieldCode="'Code'"/>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                    <MdDateTime
                        :Label="'Date From 5'"
                        :Model="Claim.occurrence.occurencedatefrom5"
                        @input="Claim.occurrence.occurencedatefrom5 = $event"
                        :Id="'DateFrom5'"
                        :Type="'date'"
                        :isRequired="false"
                        :isConfirm="false"
                        :ReadOnly="false">
                    </MdDateTime>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                 <MdDateTime
                        :Label="'Date To 5'"
                        :Model="Claim.occurrence.occurencedateto5"
                        @input="Claim.occurrence.occurencedateto5 = $event"
                        :Id="'DateTo5'"
                        :Type="'date'"
                        :isRequired="false"
                        :isConfirm="false"
                        :ReadOnly="false">
                    </MdDateTime>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="4" md="4" sm="12">
                <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 6'"
                    v-bind:ModelCode="Claim.occurrence.occurencespancode6"
                    v-bind:ModelDescription="Claim.occurrence.occurencespancode6description"
                    v-bind:RefCode="'Ospan6'"
                    v-bind:Api="'Occurrences'"
                    v-bind:FieldCode="'code'"
                     v-bind:Fields="[]"
                    v-bind:FieldDescription="'description'"
                    :SearchTitle="'Occurrence 6'"
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrencespan6'"
                    :GetValues="onCodeConditionOkModal"
                    :SearchFieldCode="'Code'"/>
            </b-col>
             <b-col lg="4" md="4" sm="12">
                    <MdDateTime
                        :Label="'Date From 6'"
                        :Model="Claim.occurrence.occurencedatefrom6"
                        @input="Claim.occurrence.occurencedatefrom6 = $event"
                        :Id="'DateFrom6'"
                        :Type="'date'"
                        :isRequired="false"
                        :isConfirm="false"
                        :ReadOnly="false">
                    </MdDateTime>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                 <MdDateTime
                        :Label="'Date To 6'"
                        :Model="Claim.occurrence.occurencedateto6"
                        @input="Claim.occurrence.occurencedateto6 = $event"
                        :Id="'DateTo6'"
                        :Type="'date'"
                        :isRequired="false"
                        :isConfirm="false"
                        :ReadOnly="false">
                    </MdDateTime>
            </b-col>
        </b-row>
         <b-row>
            <b-col lg="4" md="4" sm="12">
                <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 7'"
                    v-bind:ModelCode="Claim.occurrence.occurencespancode7"
                    v-bind:ModelDescription="Claim.occurrence.occurencespancode7description"
                    v-bind:RefCode="'Ospan7'"
                    v-bind:Api="'Occurrences'"
                    v-bind:FieldCode="'code'"
                     v-bind:Fields="[]"
                    v-bind:FieldDescription="'description'"
                    :SearchTitle="'Occurrence 7'"
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrenceSpan7'"
                    :GetValues="onCodeConditionOkModal"
                    :SearchFieldCode="'Code'"/>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                    <MdDateTime
                        :Label="'Date From 7'"
                        :Model="Claim.occurrence.occurencedatefrom7"
                        @input="Claim.occurrence.occurencedatefrom7 = $event"
                        :Id="'DateFrom7'"
                        :Type="'date'"
                        :isRequired="false"
                        :isConfirm="false"
                        :ReadOnly="false">
                    </MdDateTime>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                 <MdDateTime
                        :Label="'Date To 7'"
                        :Model="Claim.occurrence.occurencedateto7"
                        @input="Claim.occurrence.occurencedateto7 = $event"
                        :Id="'DateTo7'"
                        :Type="'date'"
                        :isRequired="false"
                        :isConfirm="false"
                        :ReadOnly="false">
                    </MdDateTime>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="4" md="4" sm="12">
                <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 8'"
                    v-bind:ModelCode="Claim.occurrence.occurencespancode8"
                    v-bind:ModelDescription="Claim.occurrence.occurencespancode8description"
                    v-bind:RefCode="'Ospan8'"
                    v-bind:Api="'Occurrences'"
                    v-bind:FieldCode="'code'"
                     v-bind:Fields="[]"
                    v-bind:FieldDescription="'description'"
                    :SearchTitle="'Occurrence 8'"
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrenceSpan8'"
                    :GetValues="onCodeConditionOkModal"
                    :SearchFieldCode="'Code'"/>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                    <MdDateTime
                        :Label="'Date From 8'"
                        :Model="Claim.occurrence.occurencedatefrom8"
                        @input="Claim.occurrence.occurencedatefrom8 = $event"
                        :Id="'DateFrom8'"
                        :Type="'date'"
                        :isRequired="false"
                        :isConfirm="false"
                        :ReadOnly="false">
                    </MdDateTime>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                 <MdDateTime
                        :Label="'Date To 8'"
                        :Model="Claim.occurrence.occurencedateto8"
                        @input="Claim.occurrence.occurencedateto8 = $event"
                        :Id="'DateTo8'"
                        :Type="'date'"
                        :isRequired="false"
                        :isConfirm="false"
                        :ReadOnly="false">
                    </MdDateTime>
            </b-col>
        </b-row>
         <b-row>
            <b-col lg="4" md="4" sm="12">
                <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 9'"
                    v-bind:ModelCode="Claim.occurrence.occurencespancode8"
                    v-bind:ModelDescription="Claim.occurrence.occurencespancode9description"
                    v-bind:RefCode="'Ospan9'"
                    v-bind:Api="'Occurrences'"
                     v-bind:Fields="[]"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'description'"
                    :SearchTitle="'Occurrence 9'"
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrenceSpan9'"
                    :GetValues="onCodeConditionOkModal"
                    :SearchFieldCode="'Code'"/>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                    <MdDateTime
                        :Label="'Date From 9'"
                        :Model="Claim.occurrence.occurencedatefrom9"
                        @input="Claim.occurrence.occurencedatefrom9 = $event"
                        :Id="'DateFrom9'"
                        :Type="'date'"
                        :isRequired="false"
                        :isConfirm="false"
                        :ReadOnly="false">
                    </MdDateTime>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                 <MdDateTime
                        :Label="'Date To 9'"
                        :Model="Claim.occurrence.occurencedateto9"
                        @input="Claim.occurrence.occurencedateto9= $event"
                        :Id="'DateTo9'"
                        :Type="'date'"
                        :isRequired="false"
                        :isConfirm="false"
                        :ReadOnly="false">
                    </MdDateTime>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="4" md="4" sm="12">
                <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 10'"
                    v-bind:ModelCode="Claim.occurrence.occurencespancode10"
                    v-bind:ModelDescription="Claim.occurrence.occurencespancode10description"
                    v-bind:RefCode="'Ospan10'"
                    v-bind:Api="'Occurrences'"
                    v-bind:FieldCode="'code'"
                     v-bind:Fields="[]"
                    v-bind:FieldDescription="'description'"
                    :SearchTitle="'Occurrence 10'"
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrenceSpan10'"
                    :GetValues="onCodeConditionOkModal"
                    :SearchFieldCode="'Code'"/>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                    <MdDateTime
                        :Label="'Date From 10'"
                        :Model="Claim.occurrence.occurencedatefrom10"
                        @input="Claim.occurrence.occurencedatefrom10 = $event"
                        :Id="'DateFrom10'"
                        :Type="'date'"
                        :isRequired="false"
                        :isConfirm="false"
                        :ReadOnly="false">
                    </MdDateTime>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                 <MdDateTime
                        :Label="'Date To 10'"
                        :Model="Claim.occurrence.occurencedateto10"
                        @input="Claim.occurrence.occurencedateto10= $event"
                        :Id="'DateTo10'"
                        :Type="'date'"
                        :isRequired="false"
                        :isConfirm="false"
                        :ReadOnly="false">
                    </MdDateTime>
            </b-col>
        </b-row>
         <b-row>
            <b-col lg="4" md="4" sm="12">
                <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 11'"
                    v-bind:ModelCode="Claim.occurrence.occurencespancode11"
                    v-bind:ModelDescription="Claim.occurrence.occurencespancode11description"
                    v-bind:RefCode="'Ospan11'"
                    v-bind:Api="'Occurrences'"
                     v-bind:Fields="[]"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'description'"
                    :SearchTitle="'Occurrence 11'"
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrenceSpan11'"
                    :GetValues="onCodeConditionOkModal"
                    :SearchFieldCode="'Code'"/>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                    <MdDateTime
                        :Label="'Date From 11'"
                        :Model="Claim.occurrence.occurencedatefrom11"
                        @input="Claim.occurrence.occurencedatefrom11 = $event"
                        :Id="'DateFrom11'"
                        :Type="'date'"
                        :isRequired="false"
                        :isConfirm="false"
                        :ReadOnly="false">
                    </MdDateTime>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                 <MdDateTime
                        :Label="'Date To 11'"
                        :Model="Claim.occurrence.occurencedateto11"
                        @input="Claim.occurrence.occurencedateto11= $event"
                        :Id="'DateTo11'"
                        :Type="'date'"
                        :isRequired="false"
                        :isConfirm="false"
                        :ReadOnly="false">
                    </MdDateTime>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="4" md="4" sm="12">
                <MdLookup
                    v-bind:Label="$t('Shared.Code')+' 12'"
                    v-bind:ModelCode="Claim.occurrence.occurencespancode12"
                    v-bind:ModelDescription="Claim.occurrence.occurencespancode12description"
                    v-bind:RefCode="'Ospan12'"
                    v-bind:Api="'Occurrences'"
                    v-bind:FieldCode="'code'"
                     v-bind:Fields="[]"
                    v-bind:FieldDescription="'description'"
                    :SearchTitle="'Occurrence 12'"
                    v-bind:isConcatModalId="true"
                    v-bind:ConcatModalId="'iModalClaimOccurrenceSpan12'"
                    :GetValues="onCodeConditionOkModal"
                    :SearchFieldCode="'Code'"/>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                    <MdDateTime
                        :Label="'Date From 12'"
                        :Model="Claim.occurrence.occurencedatefrom12"
                        @input="Claim.occurrence.occurencedatefrom12 = $event"
                        :Id="'DateFrom12'"
                        :Type="'date'"
                        :isRequired="false"
                        :isConfirm="false"
                        :ReadOnly="false">
                    </MdDateTime>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                 <MdDateTime
                        :Label="'Date To 12'"
                        :Model="Claim.occurrence.occurencedateto12"
                        @input="Claim.occurrence.occurencedateto12= $event"
                        :Id="'DateTo12'"
                        :Type="'date'"
                        :isRequired="false"
                        :isConfirm="false"
                        :ReadOnly="false">
                    </MdDateTime>
            </b-col>
        </b-row>

        <MdTitle v-bind:Text="'Authorization'"  class="mb-1" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

        <b-row>
            <b-col lg="4" md="4" sm="12">
                <MdEdit
                    v-bind:Label="'Authorization 1'"
                    v-bind:TypeProp="'text'"
                    v-bind:Name="'Authorization1'"
                    v-model="Claim.occurrence.authorization1"
                    v-bind:Id="'input_ClaimAuthorization1'"/>
            </b-col>
             <b-col lg="4" md="4" sm="12">
                <MdEdit
                    v-bind:Label="'Authorization 2/ Resub Corrected Claim'"
                    v-bind:TypeProp="'text'"
                    v-bind:Name="'Authorization2'"
                    v-model="Claim.occurrence.authorization2"
                    v-bind:Id="'input_ClaimAuthorization2'"/>
            </b-col>
             <b-col lg="4" md="4" sm="12">
                <MdEdit
                    v-bind:Label="'Authorization 3/ Resub Voided Claim'"
                    v-bind:TypeProp="'text'"
                    v-bind:Name="'Authorization3'"
                    v-model="Claim.occurrence.authorization3"
                    v-bind:Id="'input_ClaimAuthorization3'"/>
            </b-col>
        </b-row>

      </form>
     </b-modal>

    </div>
</template>

 <script>
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import Loading from '@/components/template/loading/Loading'
//import ISetup from '@/services/isetup.service'
//import { EventBus } from '@/event-bus.js';


 export default {
    name: 'ModalClaimOOccAuthoCondition',
    components: { Loading },
    mixins: [ShowMessage, DBFunctions],
    props: {
        ModalId: String,
        TitleWindow: String,
        Claim:Object
    },

   data(){
     return {
        Load: false,
        ClaimOccurrenceCopy:{},
     }
   },

   methods:{

    ChangeDateFromSpan1(){
    },

    ChangeDateToSpan1(){
    },
    ChangeDateFromSpan2(){
    },

    ChangeDateToSpan2(){
    },
    ChangeDateFromSpan3(){
    },

    ChangeDateToSpan3(){
    },
    ChangeDateFromSpan4(){
    },

    ChangeDateToSpan4(){
    },
    ChangeDateFromSpan5(){
    },

    ChangeDateToSpan5(){
    },
    ChangeDateFromSpan6(){
    },

    ChangeDateToSpan6(){
    },
    ChangeDateFromSpan7(){
    },

    ChangeDateToSpan7(){
    },
    ChangeDateFromSpan8(){
    },

    ChangeDateToSpan8(){
    },
    ChangeDateFromSpan9(){
    },

    ChangeDateToSpan9(){
    },
    ChangeDateFromSpan10(){
    },

    ChangeDateToSpan10(){
    },
    ChangeDateFromSpan11(){
    },

    ChangeDateToSpan11(){
    },
    ChangeDateFromSpan12(){
    },

    ChangeDateToSpan12(){
    },






    ChangeDate1(){

    },

    ChangeDate2(){

    },

    ChangeDate3(){

    },
    ChangeDate4(){

    },
    ChangeDate5(){

    },
    ChangeDate6(){

    },
    ChangeDate7(){

    },
    ChangeDate8(){

    },
    ChangeDate9(){

    },

    handleOk($event){
        $event.preventDefault();
        this.$emit('OnResetModal',true);
    },




    onCodeConditionOkModal(result){
      var type = result.FieldName;
           if(type.indexOf('Condition') >= 0){
                 switch (type) {
                    case "Condition1":
                        this.Claim.conditionCode1 = result.code;
                        this.Claim.conditionCode1Description = result.description;
                    break;
                    case "Condition2":
                        this.Claim.conditionCode2 = result.code;
                        this.Claim.conditionCode2Description = result.description;
                    break;
                    case "Condition3":
                        this.Claim.conditionCode3 = result.code;
                        this.Claim.conditionCode3Description = result.description;
                    break;
                    case "Condition4":
                        this.Claim.conditionCode4 = result.code;
                        this.Claim.conditionCode4Description = result.description;
                    break;
                    case "Condition5":
                        this.Claim.conditionCode5 = result.code;
                        this.Claim.conditionCode5Description = result.description;
                    break;
                    case "Condition6":
                        this.Claim.conditionCode6 = result.code;
                        this.Claim.conditionCode6Description = result.description;
                    break;
                    default:
                        this.Claim.conditionCode7 = result.code;
                        this.Claim.conditionCode7Description = result.description;
                }
            }else if(type.indexOf('Occurrence') >= 0){
                 switch (type) {
                    case "Occurrence1":
                        this.Claim.occurrence.occurencecode1 = result.code;
                        this.Claim.occurrence.occurencecode1description = result.description;
                    break;
                    case "Occurrence2":
                        this.Claim.occurrence.occurencecode2 = result.code;
                        this.Claim.occurrence.occurencecode2description = result.description;
                    break;
                    case "Occurrence3":
                        this.Claim.occurrence.occurencecode3 = result.code;
                        this.Claim.occurrence.occurencecode3description = result.description;
                    break;
                    case "Occurrence4":
                        this.Claim.occurrence.occurencecode4 = result.code;
                        this.Claim.occurrence.occurencecode4description = result.description;
                    break;
                    case "Occurrence5":
                        this.Claim.occurrence.occurencecode5 = result.code;
                        this.Claim.occurrence.occurencecode5description = result.description;
                    break;
                    case "Occurrence6":
                        this.Claim.occurrence.occurencecode6 = result.code;
                        this.Claim.occurrence.occurencecode6description = result.description;
                    break;
                    case "Occurrence7":
                        this.Claim.occurrence.occurencecode7 = result.code;
                        this.Claim.occurrence.occurencecode7description = result.description;
                    break;
                    case "Occurrence8":
                        this.Claim.occurrence.occurencecode8 = result.code;
                        this.Claim.occurrence.occurencecode8description = result.description;
                    break;
                    default:
                        this.Claim.occurrence.occurencecode9 = result.code;
                        this.Claim.occurrence.occurencecode9description = result.description;
                }
            }else if(type.indexOf('Ospan') >= 0){
                 switch (type) {
                    case "Ospan1":
                        this.Claim.occurrence.occurencespancode1 = result.code;
                        this.Claim.occurrence.occurencespancode1description = result.description;
                    break;
                    case "Ospan2":
                        this.Claim.occurrence.occurencespancode2 = result.code;
                        this.Claim.occurrence.occurencespancode2description = result.description;
                    break;
                    case "Ospan3":
                        this.Claim.occurrence.occurencespancode3 = result.code;
                        this.Claim.occurrence.occurencespancode3description = result.description;
                    break;
                    case "Ospan4":
                        this.Claim.occurrence.occurencespancode4 = result.code;
                        this.Claim.occurrence.occurencespancode4description = result.description;
                    break;
                    case "Ospan5":
                        this.Claim.occurrence.occurencespancode5 = result.code;
                        this.Claim.occurrence.occurencespancode5description = result.description;
                    break;
                    case "Ospan6":
                        this.Claim.occurrence.occurencespancode6 = result.code;
                        this.Claim.occurrence.occurencespancode6description = result.description;
                    break;
                    case "Ospan7":
                        this.Claim.occurrence.occurencespancode7 = result.code;
                        this.Claim.occurrence.occurencespancode7description = result.description;
                    break;
                    case "Ospan8":
                        this.Claim.occurrence.occurencespancode8 = result.code;
                        this.Claim.occurrence.occurencespancode8description = result.description;
                    break;
                    case "Ospan9":
                        this.Claim.occurrence.occurencespancode9 = result.code;
                        this.Claim.occurrence.occurencespancode9description = result.description;
                    break;
                    case "Ospan10":
                        this.Claim.occurrence.occurencespancode10 = result.code;
                        this.Claim.occurrence.occurencespancode10description = result.description;
                    break;
                    case "Ospan11":
                        this.Claim.occurrence.occurencespancode11 = result.code;
                        this.Claim.occurrence.occurencespancode11description = result.description;
                    break;
                    default:
                        this.Claim.occurrence.occurencespancode12 = result.code;
                        this.Claim.occurrence.occurencespancode12description = result.description;
                }
            }

    },



    emitEventCancel(){
        this.Claim.occurrence = this.ClaimOccurrenceCopy;
        this.$emit('OnResetModal',true);
    },



   },


  mounted(){
   this.ClaimOccurrenceCopy = JSON.parse(JSON.stringify(this.Claim.occurrence));
   },
 };
 </script>

